import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const CoachOnboardingModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type CoachOnboardingModalProviderProps = {
  coachOnboardingModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const CoachOnboardingModalProvider = ({
  coachOnboardingModalRef,
  children,
}: CoachOnboardingModalProviderProps) => {
  return (
    <CoachOnboardingModalContext.Provider value={coachOnboardingModalRef}>
      {children}
    </CoachOnboardingModalContext.Provider>
  )
}

const useCoachOnboardingModal = () => {
  const coachOnboardingModalRef = useContext(CoachOnboardingModalContext)
  return coachOnboardingModalRef
}

export { CoachOnboardingModalProvider, useCoachOnboardingModal }
